<template>
    <div id="subject">
        <v-app>
			<div id="grad">
				<v-container>
					<br>
					<v-row justify="center" align="center">
						<img height="100" width="100"  :src="$route.params.img != null ? $route.params.img : this.img "/>
					</v-row>
					<br>
					<v-row justify="center" align="center" class="mx-5">
						<div ><span>{{ $route.params.name != null ? $route.params.name : this.name }}</span></div>
					</v-row>
					<br>
					<v-row justify="center" align="center" class="mx-5">
						<div><span>{{ $route.params.description != null ? $route.params.description : this.description }}</span></div>
					</v-row>
					<br>
					<v-row justify="center" align="center">
						<v-btn class="indigo links" dark="" :to="{ name:'SubjectPrep' , params:{ id: $route.params.id != null ? $route.params.id : this.id , name: $route.params.name != null ? $route.params.name : this.name }}">
							Prepare
						</v-btn>
					</v-row>
					<br>
					<v-row justify="center" align="center">
						<v-btn class="indigo links" dark="" :to="{ name:'SubjectQnA', params:{ id: $route.params.id != null ? $route.params.id : this.id , name: $route.params.name != null ? $route.params.name : this.name  }}">
							Interview Questions
						</v-btn>
					</v-row>
					<br>
					<v-row justify="center" align="center">
						<v-btn class="indigo links" dark="" :to="{ name:'SubjectMcQ' , params:{  id: $route.params.id != null ? $route.params.id : this.id , name: $route.params.name != null ? $route.params.name : this.name  }}">
							Multiple Choice Questions
						</v-btn>
					</v-row>
					<br>
					<v-row justify="center" align="center">
						<v-btn class="indigo links" dark="" :to="{ name:'SubjectQuiz' , params:{ id: $route.params.id != null ? $route.params.id : this.id , name: $route.params.name != null ? $route.params.name : this.name }}">Take Quiz</v-btn>
					</v-row>
					<br>	
					<v-row v-if="this.studymaterial != null " justify="center" align="center">
						<v-btn class="indigo links" dark="">Download Study Material</v-btn>
					</v-row>
					<br>
				</v-container>
			</div>
		</v-app>
    </div>
</template>



<script>

import db from '@/fb'

export default {
	name: 'subject',
	data () {
		return {
			id: '',
			name: '',
			code: '',
			description: '',
			img: '',
			studymaterial: ''
		}
	},
	created () {

		var id = this.$route.params.id ;
		var name =  this.$route.params.name ;
		this.studymaterial =  this.$route.params.studyMat ;
	
		if(this.StudyMaterial == null){

			console.log("Null - Study Mat");

		}

		if(name == null){
			
			//console.log('Null hai');
				let ref = db.collection('Subjects').doc(id)
        		ref.get().then(
             snapshot => {
                if (snapshot.exists) {
                    var post = snapshot.data();
					//console.log(post['Name']);
					this.name = post['Name'];
					this.description = post['Desc'];
					this.img = post['Image'];
					this.studymaterial = post['StudyMaterial'];
						
                } else {
                    console.log("No such document!");
                }     
             }
         )

		
		}


    },
	computed: {
        filteredCourses: function () {
            return this.courses.filter((course) => {
                return course.Name.toLowerCase().match(this.search.toLowerCase())
            })
        }
    }

}
</script>



<style lang="scss" scoped>

// #grad {
// 	background-image: linear-gradient(#032b54, #34bbf8);
// 	height: 100%;
// }

.links {
    text-decoration: none;
}

</style>